<template>
  <div>
    <span
      style="float: right; cursor: pointer; color: #529dfe; font-weight: bold"
      @click="OpenDialog"
    >
      <span class="userinfo" type="info"
        ><i class="el-icon-edit"></i>上课时段</span
      >
    </span>

    <el-dialog
      title="设置授课时段"
      :visible.sync="dialogVisible"
      width="560px"
      top="10vh"
      append-to-body
    >
      <div style="height: 50vh; overflow-y: scroll">
        <ul>
          <li style="border-bottom: 1px solid #f2f2f2">
            <el-tooltip
              class="item"
              effect="dark"
              content="上课时段为校区排课的时间基准,请首先设置好常用的上课时段,然后再进行排课操作."
              placement="top"
            >
              <el-button
                type="text"
                style="margin-left: 0px"
                icon="el-icon-circle-plus"
                @click="addClassTime"
                >上课时段</el-button
              >
            </el-tooltip>
          </li>
          <li
            v-for="(item, index) of educational_institution_class_day_list"
            :key="index"
            style="
              font-size: 14px;
              border-bottom: 1px solid #f2f2f2;
              padding-left: 10px;
              box-sizing: border-box;
            "
          >
            <div v-if="item.edit" style="margin: 10px 0">
              <el-time-picker
                size="small"
                v-model="updateform.start_time"
                placeholder="选择开始时间"
                value-format="HH:mm:ss"
              >
              </el-time-picker>
              至
              <el-time-picker
                size="small"
                v-model="updateform.end_time"
                placeholder="选择结束时间"
                value-format="HH:mm:ss"
              >
              </el-time-picker>

              <el-button
                type="text"
                style="margin-left: 20px"
                @click="submitClassDay(index)"
                >确定</el-button
              >
              <el-button
                type="text"
                style="margin-left: 20px"
                @click="closeUpdateClassTime(index)"
                >取消</el-button
              >
            </div>

            <div v-else>
              {{ item.start_class_date }}~{{ item.end_class_date }}
              <el-button
                type="text"
                style="margin-left: 20px"
                @click="updateClassTime(index)"
                ><i class="el-icon-edit"></i
              ></el-button>
              <el-button
                type="text"
                style="margin-left: 20px"
                @click="deleteClassDay(index)"
                ><i class="el-icon-delete"></i
              ></el-button>
            </div>
          </li>
        </ul>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="dialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBaseInfo,
  addClassDay,
  updateIsEncryption,
} from "@/api/educational";

export default {
  name: "settimes",
  props: {
    homepageBanner: Array,
    homepage_id: Number,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error("请上传图片"));
      } else {
        callback();
      }
    };
    return {
      imageId: "",
      form: {
        realname: "",
        nickname: "",
        name: "",
        fileList: [],
        fileList1: [],
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        title_one: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { min: 4, max: 8, message: "长度在 4 到 8 个字符", trigger: "blur" },
        ],
        title_two: [{ required: true, message: "请输入口号", trigger: "blur" }],
        content: [
          { required: true, message: "请填写内容介绍", trigger: "blur" },
        ],
        fileList: [{ validator: validatePass, trigger: "change" }],
      },
      uploadFileTime: false,

      dialogVisible4: false,
      educational_institution_class_day_list: [],
      is_encryption: false,
      classtime: null,
      updateform: {
        start_time: "",
        end_time: "",
      },
    };
  },
  watch: {
    homepageBanner() {
      this.tableData = this.homepageBanner;
    },
  },

  mounted() {},

  methods: {
    getBaseInfo() {
      getBaseInfo().then((res) => {
        this.educational_institution_closing_day_list =
          res.educational_institution_closing_day_list;
        this.educational_institution_class_day_list =
          res.educational_institution_class_day_list;
        this.is_encryption = res.educational_institution_obj[0].is_encryption;
      });
    },

    submitClassDay(index) {
      if (!this.updateform.start_time) {
        this.$message.warning("请选择开始时间");
        return;
      }

      if (!this.updateform.end_time) {
        this.$message.warning("请选择结束时间");
        return;
      }

      this.educational_institution_class_day_list[index].start_class_date =
        this.updateform.start_time;
      this.educational_institution_class_day_list[index].end_class_date =
        this.updateform.end_time;
      this.addClassDay("保存成功", "update", index);
    },
    addClassDay(msg, status, index) {
      let class_day_list = this.educational_institution_class_day_list.map(
        (item) => {
          return {
            start: "2020-02-02 " + item.start_class_date,
            end: "2020-02-02 " + item.end_class_date,
          };
        }
      );

      console.log("添加的时段");
      console.log(class_day_list);

      class_day_list.sort(function (a, b) {
        return b.start > a.start ? -1 : 1;
      });

      console.log("排序的时段");
      console.log(class_day_list);

      addClassDay({
        class_day_list: JSON.stringify(class_day_list),
      }).then(() => {
        if (status === "update") {
          this.educational_institution_class_day_list[index].edit = false;
          this.classtime = null;
          console.log(this.classtime);
          this.getBaseInfo();

          this.$emit("UpdateTimes");
        }
        this.$message.success(msg);
      });
    },
    deleteClassDay(index) {
      this.$confirm("确定删除当前授课时段?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.educational_institution_class_day_list.splice(index, 1);
        this.addClassDay("删除成功");
        this.$emit("UpdateTimes");
      });
    },
    closeUpdateClassTime(index) {
      console.log(index);
      this.$set(
        this.educational_institution_class_day_list[index],
        "edit",
        false
      );
      this.classtime = null;
      this.getBaseInfo();
    },
    updateClassTime(index) {
      this.$set(
        this.educational_institution_class_day_list[index],
        "edit",
        true
      );
      this.updateform.start_time =
        this.educational_institution_class_day_list[index].start_class_date +
        ":00";
      this.updateform.end_time =
        this.educational_institution_class_day_list[index].end_class_date +
        ":00";
    },
    addClassTime() {
      this.educational_institution_class_day_list.unshift({
        start_class_date: "",
        end_class_date: "",
        edit: true,
      });
    },
    updateIsEncryption() {
      updateIsEncryption({
        is_encryption: this.is_encryption,
      }).then(() => {
        this.$message.success("修改成功");
      });
    },

    OpenDialog() {
      console.log("打开账户信息");

      this.getBaseInfo();
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
.userinfo {
  color: #529dfe;
}

.userinfo:hover {
  color: #67b1ff;
}
</style>
